import React from "react";
import { Input, Modal } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { DRAWER_MASK, initialsOf } from "../../Core/modals/customerDrawerUi";
import "./v4Modals.css";

const NO_REP = { salesRepresentId: null, name: null };

const SalesRepresentativeModal = ({
  salesRepModalOpen,
  setSalesRepModalOpen,
  salesRepModalInputRef,
  salesRepresentSearchInput,
  setSalesRepresentSearchInput,
  handleSalesRepresentSearchInput,
  filteredSalesRepresentList,
  handleSalesRepresentive,
  currentRepId = null,
  itemName = "",
}) => {
  const forLine = salesRepModalOpen.title === "itemSalesRep";
  const close = () => {
    setSalesRepModalOpen({ status: false, title: "" });
    setSalesRepresentSearchInput("");
  };
  const reps = filteredSalesRepresentList || [];

  return (
    <Modal
      open={salesRepModalOpen.status}
      closable={false}
      footer={null}
      keyboard={false}
      width={480}
      className="v4m"
      styles={{ mask: DRAWER_MASK }}
      onCancel={close}
    >
      <div className="v4m-head">
        <div>
          <h2 className="v4m-title">{forLine ? "Sales rep for this line" : "Sales rep for this bill"}</h2>
          <p className="v4m-sub">{forLine && itemName ? itemName : "Applies to every item on the bill that has no rep of its own"}</p>
        </div>
        <button type="button" className="v4m-ib" aria-label="Close" onClick={close}>
          <CloseOutlined />
        </button>
      </div>
      <Input
        ref={salesRepModalInputRef}
        className="v4m-in"
        placeholder="Search name or staff code"
        allowClear={false}
        onChange={(e) => handleSalesRepresentSearchInput(e.target.value)}
        value={salesRepresentSearchInput}
        prefix={<SearchOutlined />}
      />
      <div className="v4m-list" role="listbox" aria-label="Sales reps">
        <button
          type="button"
          role="option"
          aria-selected={!currentRepId}
          className={`v4m-row${!currentRepId ? " on" : ""}`}
          onClick={() => handleSalesRepresentive(NO_REP)}
        >
          <span className="v4m-av none">—</span>
          <span className="v4m-name">No sales rep</span>
          {!currentRepId && <span className="v4m-check">Current</span>}
        </button>
        {reps.map((item, index) => {
          const on = !!currentRepId && item.salesRepresentId === currentRepId;
          return (
            <button
              type="button"
              role="option"
              aria-selected={on}
              key={`${item.name}-${index}`}
              className={`v4m-row${on ? " on" : ""}`}
              onClick={() => handleSalesRepresentive(item)}
            >
              <span className="v4m-av">{initialsOf(item.name)}</span>
              <span className="v4m-name">{item.name}</span>
              {on && <span className="v4m-check">Current</span>}
            </button>
          );
        })}
        {reps.length === 0 && salesRepresentSearchInput ? <div className="v4m-empty">No sales rep matches “{salesRepresentSearchInput}”.</div> : null}
      </div>
    </Modal>
  );
};

export default SalesRepresentativeModal;
